import React from 'react';
import DocViewerAddedField from './AddedField';
import DocViewerSignedField from './SignedField';
import DocViewerAddedNote from './AddedNote';
import { useDocViewer } from '../../Context';
import OrderDoc from '~/model/orderDoc';
import classnames from 'classnames';

const DocViewerDropLayer = (props: { pageNum: number }) => {

  /**
   * Component props:
   * pageNum {int} the number of this page
   */
  const { pageNum } = props;

  /**
   * Context vars (see: Context.tsx)
   */
  const { addedFields, fieldIsSigned, fieldIsMine, addedNotes, showNotes, orderDoc } = useDocViewer();

  // hide the drop layer if the document is complete because
  // the signatures are already applied on the document
  return <div className={classnames("doc-viewer-drop-target", { 'd-none': orderDoc.status == OrderDoc.STATUS_COMPLETE })}>
    {/* loop through all added fields */}
    {addedFields.map((field: any) => {
      // check if the field is intended for this page
      if (field.page == pageNum) {
        return <React.Fragment key={field.id}>
          {/* if the field is permanently signed
          (a.k.a. signature is recorded in the db and is applied to the pdf doc) */}
          {fieldIsSigned(field) && <DocViewerSignedField field={field} />}
          {/* if the field is not signed or it is locally signed
          (a.k.a. signature is added to the field but is not yet recorded in the db nor it is applied to the pdf doc)
          and if the field is intended for the current signer */}
          {!fieldIsSigned(field) && fieldIsMine(field) && <DocViewerAddedField field={field} />}
        </React.Fragment>
      }
      return null;
    })}
    {showNotes && addedNotes.map(note => {
      if (note.page == pageNum) {
        return <DocViewerAddedNote key={note.id} note={note} />
      }
      return null;
    })}
  </div>
}

export default DocViewerDropLayer;